"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSquidStyles = void 0;
var types_1 = require("./types");
var convertKeyValueToCssVar = function (key, value) {
    return "--".concat(key, ": ").concat(value);
};
var PLACEHOLDER = /^{(.*)}$/;
var RGBAVAR = /rgba\(({.*}),(.*)\)/;
var decimalToHex = function (p) {
    return Math.ceil((p * 255) / 100)
        .toString(16)
        .toUpperCase();
};
var recursivelyResolveReferenceFromMap = function (map, key) {
    var placeHolderMatch = key.match(PLACEHOLDER);
    if (!placeHolderMatch)
        return key;
    var nextKey = map[placeHolderMatch[1]];
    if (!nextKey || typeof nextKey !== 'string')
        return key;
    return recursivelyResolveReferenceFromMap(map, nextKey);
};
var convertTokensToVars = function (tokens) {
    var newTokens = __assign(__assign({}, types_1.defaultStyles), tokens);
    return Object.entries(newTokens)
        .map(function (_a) {
        var token = _a[0], value = _a[1];
        if (typeof value !== 'string')
            return convertKeyValueToCssVar(token, value);
        var match = value.match(RGBAVAR);
        if (match) {
            var ref = match[1], percentage = match[2];
            var resolved_1 = recursivelyResolveReferenceFromMap(newTokens, ref);
            var alpha = decimalToHex(+percentage * 100).padStart(2, '0');
            return convertKeyValueToCssVar(token, "".concat(resolved_1).concat(alpha));
        }
        var resolved = recursivelyResolveReferenceFromMap(newTokens, value);
        return convertKeyValueToCssVar(token, resolved);
    })
        .join(';\n');
};
var createSquidStyles = function (tokens, selector) {
    if (tokens === void 0) { tokens = {}; }
    if (selector === void 0) { selector = ':root'; }
    return "".concat(selector, " {").concat(convertTokensToVars(tokens), " }");
};
exports.createSquidStyles = createSquidStyles;
